var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleColorV2 = function SvgGoogleColorV2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M17.012 12a4.676 4.676 0 0 1-9.076 1.585L5.26 15.726A7.996 7.996 0 0 0 20.333 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.012 12a4.672 4.672 0 0 1-1.963 3.803l2.646 2.117A7.972 7.972 0 0 0 20.333 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "M7.654 12c.001-.54.097-1.078.282-1.585L5.26 8.273a7.956 7.956 0 0 0 0 7.454l2.676-2.142A4.647 4.647 0 0 1 7.654 12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4435",
    d: "M12.333 7.32c.99.001 1.954.317 2.752.904l2.452-2.288A7.98 7.98 0 0 0 5.26 8.273l2.676 2.142a4.683 4.683 0 0 1 4.397-3.094Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M20.333 11.396V12l-1.358 2.113h-6.34v-3.32h7.095a.603.603 0 0 1 .603.603Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleColorV2);
export default ForwardRef;